<template>
  <div>
    <div ref="serviceAnalysis" style="min-height: 600px;"></div>
  </div>
</template>

<script>
  /* Imports */
  import * as am4core from "@amcharts/amcharts4/core";
  import * as am4charts from "@amcharts/amcharts4/charts";
  import moment from 'moment'
  import am4themes_animated from "@amcharts/amcharts4/themes/animated";

  export default {
    data () {
      return {
        chart : null,
        xAxis : null,
        selected : ''
      }
    },
    props : ['timeWindow', 'data', 'avgDaily', 'dataWeekly'],
    mounted () {

      
      //handled immediately in timeWindow watcher
      this.createChart()
      // this.generateData()
      this.generateRealData()
    },
    watch : {
      timeWindow : {
        handler () {
          if(this.chart != null) this.chart.dispose();//dispose chart if exist
          this.chart = null;

          this.timeWindow == 'Bulanan' ? this.selected = 'data' : this.selected = 'dataWeekly' 

          this.createChart();
          // this.generateData();
          this.generateRealData()
        },
        immediate : true
      },
      avgDaily : function () {
        if(this.chart != null) this.chart.dispose();//dispose chart if exist
          this.chart = null;

          this.timeWindow == 'Bulanan' ? this.selected = 'data' : this.selected = 'dataWeekly' 

          this.createChart();
          // this.generateData();
          this.generateRealData()
      }
    },
    methods : {
      // generateData(){
      //   var monthNames = ['January', 'February', 'March', 'April', 'May', 'June']

      //   var length = this.chart.data.length;
      //   var compiledData = []

      //   for(var i = 0; i < monthNames.length; i++){
      //     var singleData = {}
      //     singleData.month = monthNames[i]
      //     singleData[`overall`] = this.randomInt(250, 500);
      //     for(var j = 1; j <= 5; j++){
      //       singleData[`minggu_${j}`] = this.randomInt(50, 100);
      //     }
      //     compiledData.push(singleData)
      //   }

      //   this.data = compiledData;
      //   this.chart.addData(compiledData, length);
      // },
      generateRealData () {
        let length = this.chart.data.length;

        let data = JSON.parse(JSON.stringify(this[this.selected]))

        if(this.timeWindow == 'Bulanan') {
          this.createSeries('overall', 'Overall Month');

          for( var i = 0 ; i < data.length ; i ++) {
            data[i].monthName = new moment(new Date(data[i].year , data[i].month - 1 , 1)).format("MMMM")
            data[i].overall = this.avgDaily == 'Total Service' ? data[i].service : data[i].average

          }

          this.chart.addData(data, length)
        } else {
          let series = []
          let param = this.avgDaily == 'Total Service' ? 'Service' : 'Average'

          for(var i = 0 ; i < data.length ; i++) {
            let keys = Object.keys(data[i])

            for(var j = 0 ; j < keys.length ; j++) {
              
              if(keys[j].includes(param) && !series.includes(keys[j])){
                // console.log()
                this.createSeries(keys[j] , `Week ${series.length + 1}`)
                series.push(keys[j])
              }
                
              
              data[i].monthName = new moment(new Date(data[i].year , data[i].month - 1 , 1)).format("MMMM")

            }

          }
          // console.log(data)
          this.chart.addData(data, length)
        }

        
      },
      createChart () {
        // Themes begin
        am4core.useTheme(am4themes_animated);
        // Themes end

        this.chart = am4core.create(this.$refs.serviceAnalysis, am4charts.XYChart)
        this.chart.colors.step = 2;
        this.chart.cursor = new am4charts.XYCursor();

        this.chart.legend = new am4charts.Legend()
        this.chart.legend.labels.template.maxWidth = 95

        this.xAxis = this.chart.xAxes.push(new am4charts.CategoryAxis())
        this.xAxis.dataFields.category = 'monthName'
        this.xAxis.renderer.cellStartLocation = 0.1
        this.xAxis.renderer.cellEndLocation = 0.9
        this.xAxis.renderer.grid.template.location = 0;

        let yAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
        yAxis.min = 0;
      },
      createSeries(value, name) {
        let series = this.chart.series.push(new am4charts.ColumnSeries())
        series.dataFields.valueY = value
        series.dataFields.categoryX = 'monthName'
        series.name = name
        series.tooltipText = `{categoryX} ${this.avgDaily} {name}: [bold]{valueY}[/]`;

        series.events.on("hidden", this.arrangeColumns);
        series.events.on("shown", this.arrangeColumns);

        let bullet = series.bullets.push(new am4charts.LabelBullet())
        bullet.interactionsEnabled = false
        bullet.dy = 30;
        bullet.label.text = '{valueY}'
        bullet.label.fill = am4core.color('#ffffff')

        return series;
      },
      arrangeColumns() {
        let series = this.chart.series.getIndex(0);

        let w = 1 - this.xAxis.renderer.cellStartLocation - (1 - this.xAxis.renderer.cellEndLocation);
        if (series.dataItems.length > 1) {
          let x0 = this.xAxis.getX(series.dataItems.getIndex(0), "categoryX");
          let x1 = this.xAxis.getX(series.dataItems.getIndex(1), "categoryX");
          let delta = ((x1 - x0) / this.chart.series.length) * w;
          if (am4core.isNumber(delta)) {
            let middle = this.chart.series.length / 2;

            let newIndex = 0;
            this.chart.series.each((series)=>{
              if (!series.isHidden && !series.isHiding) {
                series.dummyData = newIndex;
                newIndex++;
              }
              else {
                series.dummyData = this.chart.series.indexOf(series);
              }
            })
            let visibleCount = newIndex;
            let newMiddle = visibleCount / 2;

            this.chart.series.each((series)=>{
              let trueIndex = this.chart.series.indexOf(series);
              let newIndex = series.dummyData;

              let dx = (newIndex - trueIndex + middle - newMiddle) * delta

              series.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
              series.bulletsContainer.animate({ property: "dx", to: dx }, series.interpolationDuration, series.interpolationEasing);
            })
          }
        }
      }
    }
  }
</script>

<style scoped>

</style>